import { render, staticRenderFns } from "./OperationTypeForm.vue?vue&type=template&id=2047394c"
import script from "./OperationTypeForm.vue?vue&type=script&lang=js"
export * from "./OperationTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports